// Shared Favorites Functionality

// Get customer ID from Liquid template
const customerId = window.customerId || null;
const favoritesApiUrl = KROWN.settings.api_urls.preferences_app_url + '/favorites/update';

// Favorite toggle functionality
function toggleFavorite(element, productId) {
  try {
    // Toggle visual state immediately for better UX
    element.classList.toggle('active');

    // Check if we're adding or removing from favorites
    const isActive = element.classList.contains('active');

    // Get current favorites (try localStorage first, then metafields)
    let favorites = getFavorites();

    if (isActive) {
      // Add to favorites if not already there
      if (!favorites.includes(parseInt(productId))) {
        favorites.push(parseInt(productId));
      }
    } else {
      // Remove from favorites
      favorites = favorites.filter((id) => id !== parseInt(productId));
    }

    // Update all heart icons on the page with the same product ID
    updateAllHeartStates(productId, isActive);

    // Save to both localStorage (for immediate UI) and API (for persistence)
    localStorage.setItem('customerFavorites', JSON.stringify(favorites));

    if (customerId) {
      updateFavoritesAPI(favorites);
    }

    // Trigger resort if the function exists (on collection pages)
    // if (typeof applyFavoritesSorting === 'function') {
    //   applyFavoritesSorting();
    // }
    // Removed above call to prevent auto-reordering which may cause confusion to user
    // Left commented in case we want to re-enable it later
  } catch (error) {
    console.error('Error updating favorites:', error);
    // Revert visual state if error occurred
    element.classList.toggle('active');
    alert('Unable to update favorites. Please try again.');
  }
}

// Update favorites via API
async function updateFavoritesAPI(favorites) {
  if (!customerId) {
    // No customer ID, skipping API update
    return;
  }

  try {
    const response = await fetch(favoritesApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        favoriteProducts: favorites,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to update favorites');
    }
  } catch (error) {
    console.error('Error saving favorites to API:', error);
    // Don't show error to user since localStorage still works
  }
}

// Update all heart icons for a specific product across the page
function updateAllHeartStates(productId, isActive) {
  const allHearts = document.querySelectorAll(`[data-product-id="${productId}"]`);
  allHearts.forEach((heart) => {
    if (isActive) {
      heart.classList.add('active');
    } else {
      heart.classList.remove('active');
    }
  });
}

// Initialize all favorite hearts on page load
function initializeFavorites() {
  const favorites = getFavorites();
  const allHearts = document.querySelectorAll('.favorite-heart');

  allHearts.forEach((heart) => {
    const productId = parseInt(heart.getAttribute('data-product-id'));
    if (favorites.includes(productId)) {
      heart.classList.add('active');
    }
  });
}

// Get all favorited products.
// Prefer localStorage window.customerFavorites (can become stale after changes on other pages like order history).
function getFavorites() {
  const stored = JSON.parse(localStorage.getItem('customerFavorites') || 'null');
  if (stored && Array.isArray(stored)) return stored;

  if (window.customerFavorites && Array.isArray(window.customerFavorites)) return window.customerFavorites;

  return [];
}

// Check if a product is favorited
function isFavorited(productId) {
  const favorites = getFavorites();
  return favorites.includes(parseInt(productId));
}

function rehydrateFavorites() {
  initializeFavorites();
  if (typeof window.applyFavoritesSorting === 'function') window.applyFavoritesSorting();
}

document.addEventListener('DOMContentLoaded', function () {
  rehydrateFavorites();

  // Ensure AJAX grid re-renders updates favorites
  const grid = document.getElementById('CollectionProductGrid');
  if (grid) {
    new MutationObserver(rehydrateFavorites).observe(grid, { childList: true, subtree: true });
  }
});

// Make functions globally available
window.toggleFavorite = toggleFavorite;
window.getFavorites = getFavorites;
window.isFavorited = isFavorited;
